<template>
  <EditorButton :title="$t('font_size')" class="rich-editor-button">
    <template v-slot:trigger="{ hide, show }">
      <FlotoDropdownPicker
        :options="options"
        :value="value"
        @change="handleOptionSelected"
      >
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="small-icon-button"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
      </FlotoDropdownPicker>
    </template>
  </EditorButton>
</template>

<script>
import EditorButton from './editor-button'
import { DEFAULT_FONT_SIZES } from './plugins/font-size'
export default {
  name: 'FontSizeButton',
  components: { EditorButton },
  props: {
    value: { type: String, default: undefined },
  },
  computed: {
    options() {
      const o = [
        { text: this.$tc('default'), key: '12.8' },
        ...DEFAULT_FONT_SIZES.map((s) => ({ text: s, key: s })),
      ]
      return o
    },
  },
  methods: {
    handleOptionSelected(key) {
      this.$emit('change', key)
    },
  },
}
</script>
